const Dark = {
    components: {
        Form: {
            verticalLabelPadding: '0 0 3px',
            itemMarginBottom: 10,
        },
        Layout: {
            siderBg: '#1A1A1A !important',
            bodyBg: '#1A1A1A',
        },
        Input: {
            borderRadius: 5,
            borderRadiusLG: 5,
            fontSize: 14,
            fontSizeLG: 14,
            colorBgContainer: '#1F1F1F',
            colorBorder: '#565656',
            colorIcon: '#4B4B4B',
            colorTextDisabled: '#474747',
        },
        InputNumber: {
            colorBgContainer: '#1F1F1F',
            colorBorder: '#565656',
            colorIcon: '#4B4B4B',
            colorTextDisabled: '#474747',
        },
        Select: {
            borderRadius: 10,
            fontSize: 16,
            colorBorder: '#565656',
            activeBorderColor: '#3A56DF',
            hoverBorderColor: '#3A56DF',
            optionSelectedBg: '#8CA0FF',
            selectorBg: '#1F1F1F',
            colorBgElevated: '#1F1F1F',
            colorTextQuaternary: '#FFFFFF',
            optionActiveBg: '#3A56DF',
            colorIcon: '#FFFFFF',
            colorTextPlaceholder: '#FFFFFF',
        },
        Button: {
            fontSize: 14,
            colorBgContainer: 'transparent',
            defaultBorderColor: '#313131',
            colorTextDisabled: '#2C2C2C',
        },
        Modal: {
            headerBg: '#1F1F1F',
            contentBg: '#1F1F1F',
            colorIcon: '#FFFFFF',
            borderRadiusLG: 20,
        },
        Alert: {
            colorErrorBorder: '#313131',
            colorSuccessBorder: '#313131',
            colorInfoBorder: '#313131',
            colorWarningBorder: '#313131',
            colorWarningBg: '#de6a04',
            colorSuccessBg: '#0d8500',
        },
        Steps: {
            colorSplit: '#FFFFFF',
            colorFillContent: '#4B4B4B',
        },
        Tabs: {
            colorTextDisabled: '#2C2C2C',
        },
        Segmented: {
            itemColor: '#4E4E4E',
            itemSelectedColor: '#FFFFFF',
            itemHoverBg: '#262626',
            itemSelectedBg: '#3954D8',
            trackBg: '#262626',
        },
        DatePicker: {
            colorBgElevated: '#1F1F1F',
            activeBg: '#3954D8',
            colorTextDisabled: '#474747',
        },
        Table: {
            colorBgContainer: '#1F1F1F',
            headerBg: '#1F1F1F',
            borderColor: '#323131',
            // stickyScrollBarBg: 'red',
            cellFontSize: 16,
            cellFontSizeMD: 16,
            cellFontSizeSM: 16,
            colorIcon: '#4E4E4E',
        },
        Popover: {
            colorBgElevated: '#1F1F1F',
        },
        Checkbox: {
            colorBgContainer: '#1F1F1F',
            colorBorder: '#474747',
        },
        Dropdown: {
            colorBgElevated: '#1F1F1F',
            colorTextDisabled: '#474747',
        },
        Radio: {
            colorBgContainer: '#1F1F1F',
        },
    },
    token: {
        colorTextDisabled: '#474747',
        colorErrorBg: '#ff7875',
        colorSuccessBg: '#95de64',
        colorInfoBg: '#355776',
        colorPrimary: '#3A56DF',
        colorText: '#FFFFFF',
        colorTextDescription: '#565656',
        colorTextPlaceholder: '#565656',
        fontFamily: 'Titillium Web, sans-serif',
    },
};

export default Dark;
